// WhatsApp helpers — Khasim Trendz
export const WA_NUMBER = "919885544389"; // E.164 with India country code
export const STORE_NAME = "Khasim Trendz";
export const STORE_LOCATION = "Buttaipet, Machilipatnam";

export function waLink(message) {
  const text = encodeURIComponent(message);
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
}

export function waProductLink(product) {
  const price = product?.price ? ` (₹${product.price})` : "";
  const msg = `Hi ${STORE_NAME}! I'm interested in *${product?.name || "your products"}*${price}. Is it available?`;
  return waLink(msg);
}

export function waCategoryLink(categoryName) {
  return waLink(`Hi ${STORE_NAME}! I'd like to see your *${categoryName}* collection. Please share more details.`);
}

export function waGeneralLink() {
  return waLink(`Hi ${STORE_NAME}! I'd like to know more about your store and collections.`);
}
